export default "__VITE_ASSET__dd86d445__"